export enum DigestRecurrence {
  Yearly = 0,
  Monthly,
  Weekly,
  Daily,
  ASAP,
  Quarterly,
}

export enum DigestDateOrdinal {
  First = 0,
  Last = -1,
}

export enum DigestStatus {
  Cancelled = `cancelled`,
  Complete = `complete`,
  Failed = `failed`,
  Paused = `paused`,
  Pending = `pending`,
  Scheduled = `scheduled`,
}

export enum EmailDigestFieldError {
  None = 0,
  NameEmpty,
  NameTooLong,
  DashboardEmpty,
  DashboardForeignPrivate,
  PrivateDashboardsNotAllowed,
  RecipientsEmpty,
  RecipientsInvalid,
  FrequencyInvalid,
  ValidationFailed,
}
